module.exports = __webpack_public_path__ + "img/characterAnime27.f72d36f7.png";